import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonGroup, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { AuthPasswordField, FieldControl, } from "@pangeacyber/react-mui-shared";
import { useStoreFileViewerContext } from "../../hooks/context";
import { passwordGenerator } from "../../utils";
var UnControlledPasswordWithGenerateField = function (_a) {
    var _b;
    var onValueChange = _a.onValueChange, props = __rest(_a, ["onValueChange"]);
    var theme = useTheme();
    var configurations = useStoreFileViewerContext().configurations;
    var value = props.value;
    return (_jsx(Stack, { spacing: 0.5, children: _jsx(Stack, { width: "100%", children: _jsxs(ButtonGroup, { sx: {
                    flexGrow: 1,
                    width: "100%",
                    ".MuiFormGroup-root": {
                        width: "calc(100% - 170px)",
                    },
                    ".MuiPopper-root": {
                        zIndex: theme.zIndex.modal + 1,
                    },
                }, children: [_jsx(AuthPasswordField, __assign({}, props, { label: "", value: value, onValueChange: onValueChange, FieldProps: __assign(__assign({}, props === null || props === void 0 ? void 0 : props.FieldProps), { type: "passwordWithPolicy", policy: (_b = configurations === null || configurations === void 0 ? void 0 : configurations.passwordPolicy) !== null && _b !== void 0 ? _b : {
                                chars_min: 8,
                            }, InputProps: {
                                fullWidth: true,
                                sx: {
                                    borderBottomRightRadius: "0!important",
                                    borderTopRightRadius: "0!important",
                                },
                            } }) })), _jsx(Button, { variant: "contained", color: "secondary", onClick: function () {
                            return !!onValueChange && onValueChange(passwordGenerator(10));
                        }, sx: {
                            color: theme.palette.primary.main,
                            borderBottomLeftRadius: "0!important",
                            borderTopLeftRadius: "0!important",
                            boxShadow: "none",
                            zIndex: 0,
                            flex: 1,
                        }, children: "Generate password" })] }) }) }));
};
var PasswordWithGenerateField = function (props) {
    return (_jsx(FieldControl, __assign({}, props, { errors: undefined, children: _jsx(UnControlledPasswordWithGenerateField, __assign({}, props)) })));
};
export default PasswordWithGenerateField;
